import React, { Fragment, useMemo } from 'react'
import PropTypes from 'prop-types'
import TrackingLink from '../../../functional-components/TrackingLink'
import { FLOW_TYPES, ORIGINS } from '../../../data-tagging/constants'
import SocialButtonGroup from '../components/SocialButtonGroup'
import CampaignSeal from '../components/CampaignSeal'
import texts from '../../../common/texts.json'
import Collapse from 'reactstrap/lib/Collapse'
import CardBody from 'reactstrap/lib/CardBody'
const SECTION_NAME = 'footer_section_link'

const renderLinks = (links) => {
  return links.map((link, ix) => (
    <div className="row footer-menu-link" key={ix}>
      <TrackingLink
        href={link.href}
        target={link.target}
        sectionName={SECTION_NAME}
        flowType={FLOW_TYPES.FOOTER}
        origin={ORIGINS.FOOTER}
        sectionItem={link.label}
      >
        {link.label}
      </TrackingLink>
    </div>
  ))
}

const toggle = (data, category, setData) => {
  const tempData = {
    ...data,
  }
  tempData[category].isOpen = !data[category].isOpen
  setData(tempData)
  if (data[category].isOpen) {
    setTimeout(() => {
      document.getElementById('end-footer').scrollIntoView({ behavior: 'smooth', block: 'end' })
    }, 200)
  }
}

const DesktopFooter = ({ data, campaignSeal }) => {
  return (
    <>
      <div className="row" data-testid="footer-render-desktop">
        <div className="col-1" />
        {Object.keys(data).map((category, ix) => (
          <Fragment key={ix}>
            <div className="col-2">
              <div className="d-flex pt-10 pb-10 font-16">{category}</div>
              {data[category].links.map((link, ij) => (
                <div className="d-flex pt-5 pb-5 text-left" key={ij}>
                  <TrackingLink
                    className="font-weight-normal text-white"
                    href={link.href}
                    target={link.target}
                    sectionName={SECTION_NAME}
                    flowType={FLOW_TYPES.FOOTER}
                    origin={ORIGINS.FOOTER}
                    sectionItem={link.label}
                  >
                    {link.label}
                  </TrackingLink>
                </div>
              ))}
            </div>
          </Fragment>
        ))}
        <div className="col-3">
          <div className="d-flex pt-10 pb-10 font-16">{texts.FOOTER.CONTACT_US_TITLE}</div>
          <div className="d-flex">
            <SocialButtonGroup />
          </div>
          {campaignSeal?.active && (
            <div className="d-flex pt-30">
              <CampaignSeal logo={campaignSeal?.logo} />
            </div>
          )}
        </div>
        <div className="col-1" />
      </div>
    </>
  )
}

const MobileFooter = ({ data, setData, campaignSeal }) => {
  return (
    <>
      <div className="row">
        <div className="col-12">
          <div className="footer_contact-us-title">
            <span>{texts.FOOTER.CONTACT_US_TITLE}</span>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-12">
          <div className="footer-social">
            <SocialButtonGroup />
            {campaignSeal?.active && (
              <CampaignSeal className="footer_campaign-seal-logo-mb" logo={campaignSeal?.logo} />
            )}
          </div>
        </div>
      </div>
      <div className="footer-menu" data-testid="footer-render-mobile">
        {Object.keys(data).map((category, ix) => {
          const categoryObject = data[category]
          return (
            <Fragment key={ix}>
              <div className="footer-menu-category">
                <div
                  role="presentation"
                  className="d-flex justify-content-between"
                  onClick={() => toggle(data, category, setData)}
                >
                  {category}
                  <img
                    alt="white-arrow"
                    height={24}
                    src="/catalogo/images/arrow_white.svg"
                    style={{ transform: categoryObject.isOpen ? 'rotate(90deg)' : 'none' }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <Collapse isOpen={categoryObject.isOpen}>
                    <CardBody>{renderLinks(categoryObject.links)}</CardBody>
                  </Collapse>
                </div>
              </div>
            </Fragment>
          )
        })}
      </div>
    </>
  )
}

DesktopFooter.defaultProps = {
  campaignSeal: {},
}

MobileFooter.defaultProps = {
  campaignSeal: {},
}

DesktopFooter.propTypes = {
  data: PropTypes.object.isRequired,
  campaignSeal: PropTypes.object,
}

MobileFooter.propTypes = {
  data: PropTypes.object.isRequired,
  setData: PropTypes.func.isRequired,
  campaignSeal: PropTypes.object,
}

const useRenderFooter = (data, setData, campaignSeal) => {
  const renderDesktop = useMemo(() => {
    return <DesktopFooter data={data} campaignSeal={campaignSeal}></DesktopFooter>
  }, [data, campaignSeal])

  const renderMobile = useMemo(() => {
    return <MobileFooter data={data} setData={setData} campaignSeal={campaignSeal}></MobileFooter>
  }, [data, campaignSeal])

  return {
    renderDesktop,
    renderMobile,
  }
}

export default useRenderFooter
